<template>
  <div>
    <div class="search-bar-margin-bottom-cla">
      <el-form :inline="true" :model="params">
        <el-form-item>
          <el-date-picker
            class="pickData_cla"
            v-model="value2"
            @clear="getStatisticApiAggs"
            align="right"
            unlink-panels
            range-separator="-"
            :start-placeholder="$t('common.startTime')"
            :end-placeholder="$t('common.endTime')"
            type="datetimerange"
            :default-time="['00:00:00', '23:59:59']"
            format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-input
            clearable
            @clear="searchFn"
            :placeholder="this.$t('common.inputKeyWord')"
            v-model.trim="params.key"
            @keyup.enter.native="getStatisticApiAggs"
          >
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="searchFn" type="primary" icon="el-icon-search">{{
            $t('common.search')
          }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="dataList">
      <el-table-column
        prop="path"
        :label="this.$t('statistics.url')"
      ></el-table-column>
      <el-table-column
        prop="fieldName"
        :label="this.$t('statistics.apiName')"
      ></el-table-column>
      <el-table-column
        prop="count"
        :label="this.$t('statistics.callCount')"
      ></el-table-column>
      <el-table-column :label="this.$t('statistics.callDetail')">
        <template slot-scope="scope">
          <el-button
            class="btn-text-cla"
            @click.stop="details(scope.row)"
            type="text"
            >{{ $t('common.details') }}</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-drawer :title="currentRow.fieldName" :visible.sync="drawer">
      <div class="api-detail-drawer-cla">
        <div class="api-detail-header">
          <img
            class="statisticsChart-icon-cla"
            src="../../../assets/new/statistics/statisticsChart.svg"
          />
          <span>{{
            $t('statistics.callTimes', { count: currentRow.count })
          }}</span>
        </div>
        <div class="list-box-cla">
          <el-table :border="true" :data="currentRow.innerList">
            <el-table-column
              prop="fieldName"
              :label="this.$t('statistics.name')"
            ></el-table-column>
            <el-table-column
              prop="count"
              :label="this.$t('statistics.callCount')"
            ></el-table-column>
          </el-table>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
// 查询条件 , apiName:
import { getLastTime, getCurrentDateStartAndEndTime } from '@/utils/utils.js'
import { getStatisticApiAggs } from '@/services/statisticsApi.js'
import { defaultShortCuts } from '@/utils/pickerOptions.js'
export default {
  data() {
    return {
      pickerOptions: defaultShortCuts(this),
      value2: getCurrentDateStartAndEndTime(),
      params: {
        // startTime: '',
        // endTime: '',
        key: '',
        appCode: 'DBS'
      },
      tableData: [],
      drawer: false,
      loadingInstance: null,
      currentRow: {},
      apiName: ''
    }
  },
  mounted() {
    let time = this.$route.params.time
    if (time) {
      this.setDefaultTime(time)
    }
    if (this.$route.params.type === 'currentDate') {
      this.apiName = this.$route.params.apiName
      this.currentDate()
    }
    this.getStatisticApiAggs()
  },

  computed: {
    dataList() {
      if (this.apiName) {
        return this.tableData.filter(item => {
          if (item.fieldName === this.apiName) {
            return true
          } else {
            return false
          }
        })
      } else {
        return this.tableData
      }
    }
  },

  methods: {
    details(row) {
      this.currentRow = row
      this.drawer = true
    },
    searchFn() {
      this.apiName = ''
      this.getStatisticApiAggs()
    },
    getStatisticApiAggs() {
      let params = Object.assign({}, this.params)
      let valueLength = this.value2 && this.value2.length === 2
      if (valueLength) {
        params.startTime = this.value2[0].getTime()
        params.endTime = this.value2[1].getTime()
      }
      if (!params.key) {
        delete params.key
      }
      this.loadingInstance = this.$loading({
        lock: true,
        fullscreen: true,
        text: '',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      getStatisticApiAggs(params)
        .then(data => {
          if (data.code === '00000000') {
            this.tableData = data.payload.data
          } else {
            this.$message.error(data.message)
          }
        })
        .catch(e => {
          this.tableData = []
          this.$message.error(e)
        })
        .finally(() => {
          this.loadingInstance.close()
        })
    },
    setDefaultTime(time) {
      let timeRange = []
      if (time === 90) {
        // 最近三个月
        timeRange = getLastTime('months', 3)
      } else if (time === 30) {
        // 最近一个月个月
        timeRange = getLastTime('months', 1)
      } else if (time === 7) {
        // 最近一周
        timeRange = getLastTime('weeks', 1)
      }
      if (timeRange.length === 2) {
        this.value2 = [new Date(timeRange[0]), new Date(timeRange[1])]
      }
    },
    currentDate() {
      let timeRange = getCurrentDateStartAndEndTime()
      this.value2 = [timeRange[0], timeRange[1]]
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/styles/var.less';
.api-detail-drawer-cla {
  padding: 12px 24px;
  .api-detail-header {
    height: 60px;
    line-height: 40px;
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 20px;
    i {
      height: 30px;
      width: 30px;
      line-height: 30px;
      color: @themeColor;
      display: inline-block;
      text-align: center;
      font-size: 30px;
      margin-right: 10px;
    }
  }
  .list-box-cla {
    .apiDetails-item-cla {
      display: flex;
      align-items: center;
      height: 40px;
      line-height: 40px;
      &:hover {
        cursor: pointer;
        background-color: rgba(0, 0, 0, 0.2);
      }
      .line-cla {
        margin-right: 10px;
        display: inline-block;
        width: 40px;
        border-bottom: 1px solid gray;
        height: 1px;
      }
      .appName-cla {
        display: inline-block;
        min-width: 40px;
        margin-right: 10px;
      }
      .appCount-cla {
        display: inline-block;
      }
    }
  }
}
/deep/.el-drawer__body {
  margin-bottom: 0px !important;
}
/deep/.el-drawer__header {
  margin-bottom: 0px !important;
  padding: 10px;
}

/deep/ .el-table--border td,
.el-table--border th {
  border-right: 0.183333rem solid #ebeef5;
}

/deep/ .el-table thead tr th {
  background: #f9fafb;
}

.statisticsChart-icon-cla {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/modules/statistics/callDetails/apiDetails.vue